import { User } from "firebase/auth";
import { apiFetch } from "./client";
import { Club } from "./clubs";

export type ClubSummary = Pick<Club, "id" | "name" | "shortName" | "crest">;

export interface PositionPrediction {
  id: string;
  clubId: string;
  position: number;
  club: ClubSummary;
}

export interface MemberPredictions {
  memberId: string;
  displayName: string;
  predictions: PositionPrediction[];
}

export interface PredictionsResponse {
  isLocked: boolean;
  myPrediction: PositionPrediction[];
  memberPredictions: MemberPredictions[] | null;
}

export function submitPrediction(
  user: User,
  leagueId: string,
  predictions: { clubId: string; position: number }[],
): Promise<{ saved: number }> {
  return apiFetch(user, `/leagues/${leagueId}/predictions`, {
    method: "POST",
    body: JSON.stringify({ predictions }),
  });
}

export function getPredictions(user: User, leagueId: string): Promise<PredictionsResponse> {
  return apiFetch(user, `/leagues/${leagueId}/predictions`);
}
